import { ApiCall } from '../ApiClient';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export const llmEndpoints = {

    selectCapability: (message: string) => get<{ code: string }>({
        path: '/llm.selectCapability',
        query: { message },
    }),

    describe: (fileUrl: string) => post<{ response: string }>({
        path: '/llm.describe',
        body: { fileUrl },
    }),

    fileToObjects: (message: string, fileUrl: string) => post<any>({
        path: '/llm.fileToObjects',
        body: { message, fileUrl },
    }),

};
